import React from "react"

import {Footer} from "../components"

export default function FooterContainer() {
    return <Footer id="contact">
        <Footer.Title>Contact Us</Footer.Title>
        <Footer.Text>Contact Name: hector</Footer.Text>
        <Footer.Text>Address: 123 Address Street, State, Country</Footer.Text>
        <Footer.Text>Email: exmaple@gmail.com</Footer.Text>
        <Footer.Text>Phone: 000-000-0000</Footer.Text> 
        <Footer.Text>Business Hours: Monday-Sunday</Footer.Text>
        <Footer.Text>Copyright: &copy;Sam Nye VR</Footer.Text>
    </Footer>
}